<template>
<div>
<Dorms/>

</div>
</template>

<script>
import Dorms from "../../components/Dorms/Dorms.vue";


export default {
  components: {
   Dorms
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>